import { NotificationPrettyMessageInput } from "@/modules/admin-panel/notification-templates/shared/notification-form/views/pretty-message-input";
import { NotificationTitleInput } from "@/modules/admin-panel/notification-templates/shared/notification-form/views/title-input";
import { NotificationBodyInput } from "@/modules/admin-panel/notification-templates/shared/notification-form/views/body-input";
import { notificationTemplateValueDtoToNotificationTemplateInput } from "@/modules/admin-panel/notification-templates/shared/notification-form/utils/notification-template-value-dto-to-notification-template-input";
import { Grid } from "./views/grid";

export const NotificationForm = {
  Title: NotificationTitleInput,
  Body: NotificationBodyInput,
  PrettyMessage: NotificationPrettyMessageInput,
  Grid,
  transformers: {
    notificationTemplateValueDtoToNotificationTemplateInput,
  },
};
